const stockTransferId = {
	stock_transfer: {
		title: "Stock Transfer",
		subtitle: "Daftar data mutasi stok antar toko",
	table: {
		title: "Data Stock Transfer",
		columns: {
			date: "Tanggal",
			ref_id: "Ref ID",
			from_store: "Toko Asal",
			to_store: "Toko Tujuan",
			notes: "Catatan",
			created_by: "Dibuat Oleh",
			status: "Status",
		},
	},
		empty_state: {
			title: {
				has_filter: "Tidak ada data yang sesuai",
				no_filter: "Tidak ada data stok Transfer",
			},
			description: {
				has_filter:
					"Tidak ditemukan data dengan filter yang dipilih. Coba ubah filter Anda.",
				no_filter: "Silakan tambahkan data stok Transfer baru.",
			},
		},
		forms: {
			edit: {
				title: "Edit Stok Transfer",
				info: "Informasi stok transfer",
				fields: {
					ref_id: {
						label: "RefId",
						placeholder: "refId",
					},
					from_store: {
						label: "Toko Asal",
						placeholder: "Pilih Toko",
					},
					to_store: {
						label: "Toko Tujuan",
						placeholder: "Pilih Toko",
					},
					notes: {
						label: "Catatan",
						placeholder: "catatan",
					},
					status: {
						label: "Status",
						placeholder: "Pilih Status",
					},
				},
				options: {
					active: "Aktif",
					inactive: "Tidak Aktif",
				},
			},
			conflict: {
				same_store: "Toko tujuan tidak boleh sama dengan toko asal",
				transfer_stock_out_of_stock: "Jumlah transfer melebihi stok asal",
			},
			add: {
				button: "Tambah Stok Transfer",
				title: "Tambah Stok Transfer",
				description: "Tambah data Stok Transfer baru",
				fields: {
					from_store: {
						label: "Toko Asal",
						placeholder: "Pilih toko",
					},
					to_store: {
						label: "Toko Tujuan",
						placeholder: "Pilih toko",
					},
					notes: {
						label: "Catatan",
						placeholder: "Masukkan Catatan",
					},
					processed_at: {
						label: "Tanggal proses",
					},
					product_detail: {
						title: "Detail Produk",
						from_product: {
							label: "Produk Asal",
							placeholder: "Pilih Produk",
							search_product: "Cari Produk...",
							not_found_product: "Tidak ada product yang ditemukan",
						},
						from_stock: {
							label: "Stock Asal",
							placeholder: "0",
						},
						to_stock: {
							label: "Stock Tujuan",
							placeholder: "0",
						},
						to_last_stock: {
							label: "Stock Tujuan Akhir",
							placeholder: "0",
						},
						to_product: {
							label: "Produk Tujuan",
							placeholder: "Pilih Produk",
							search_product: "Cari Produk...",
							not_found_product: "Tidak ada product yang ditemukan",
						},
						qty: {
							label: "QTY",
							placeholder: "0",
						},
						unit: {
							label: "Satuan",
							placeholder: "Pcs",
						},
						action: {
							label: "Aksi",
						},
					},
				},
			},
		},
		status: {
			processed: "Sudah diproses",
			inactive: "Tidak Aktif",
			active: "Aktif",
		},
		actions: {
			save: "Simpan",
			saving: "Menyimpan...",
			cancel: "Batal",
			save_changes: "Simpan Perubahan",
			add_products: {
				already_added: "Produk ini sudah ditambahkan",
				button: "Tambahkan Produk lagi",
			},
		},
	},
};

export default stockTransferId;
